/**
 * WHAT THE MASS-SEND APPROVAL SAYS (Randall, 2026-11-02). Pure, so the words can be tested.
 * Read from GET /api/admin/mail-campaigns and /api/admin/mail-campaigns/{id}: see backend/mail_campaigns.py.
 */

export const KIND_LABEL = { bulk_email: "Bulk email", reminder: "Reminder" };

export const STATUS_LABEL = {
  awaiting_approval: "Waiting for approval",
  sending: "Sending",
  sent: "Sent",
  rejected: "Rejected",
};

/** How many of the excluded are disabled, test or staff accounts, in the order an approver reads them. */
export function excludedLines(counts = {}) {
  return Object.entries(counts || {})
    .sort((a, b) => b[1] - a[1])
    .map(([reason, n]) => `${n} ${reason}`);
}

/** One line for the screen, so a stale tab cannot read as a live one. */
export function campaignLine(c = {}) {
  const who = `${c.recipient_count} ${c.recipient_count === 1 ? "person" : "people"}`;
  if (c.status === "awaiting_approval") return `${who}, nothing sent yet`;
  if (c.status === "rejected") return `${who}, rejected, nothing sent`;
  return `${c.sent_count || 0} of ${c.recipient_count} sent, ${c.failed_count || 0} failed`;
}

/** The last question before real mail goes. It has to name the count and say it cannot be undone. */
export function approveQuestion(c = {}) {
  return (
    `Send "${c.subject}" to ${c.recipient_count} ${c.recipient_count === 1 ? "person" : "people"} now?\n\n` +
    "This sends real email at once and cannot be undone."
  );
}

/** Only a campaign still waiting, in front of the one person who may decide it. */
export function canDecide(c = {}, viewerCanDecide = false) {
  return !!viewerCanDecide && c.status === "awaiting_approval";
}
